import React, {Dispatch, SetStateAction, useMemo, useState} from 'react'
import {
  Badge,
  Button,
  ButtonGroup,
  DateTimeRangePicker,
  Icon,
  Text,
} from '@therms/atalaya'
import {LocationLogEntrySearchFiltersModal} from '@therms/react-modules'
import {MdManageSearch} from 'react-icons/md'
import {IoClose} from 'react-icons/io5'

interface LocationLogEntrySearchFiltersProps {
  filtersState: {
    activityTypeIds: string[] | undefined
    selectedUserIds: string[] | undefined
    selectedEntryTypeIds: string[] | undefined
    selectedDateTimeRange: {start: undefined; end: undefined}
  }
  searchText: string
  setFiltersState: Dispatch<SetStateAction<object>>
  setSearchText: Dispatch<SetStateAction<string>>
}

function LocationLogEntrySearchFilters({
  filtersState,
  searchText,
  setFiltersState,
  setSearchText,
}: LocationLogEntrySearchFiltersProps) {
  const [showAdvanceFilters, setAdvanceFilters] = useState(false)

  const filterCount = useMemo(
    () =>
      (filtersState.activityTypeIds?.length || 0) +
      (filtersState.selectedUserIds?.length || 0) +
      (filtersState.selectedEntryTypeIds?.length || 0) +
      (filtersState.selectedDateTimeRange.start ? 1 : 0),
    [filtersState],
  )

  return (
    <div className="">
      <div className="gap-xs flex flex-wrap">
        <div>
          <Text
            placeholder="Search..."
            onChangeValue={setSearchText}
            value={searchText}
            search
          />
        </div>

        <div>
          <DateTimeRangePicker
            placeholder="Date/Time Range"
            onChangeValue={(val) => {
              setFiltersState({
                selectedDateTimeRange: val,
              })
            }}
            onClearValue={() =>
              setFiltersState({
                selectedDateTimeRange: {
                  end: undefined,
                  start: undefined,
                },
              })
            }
            value={filtersState.selectedDateTimeRange}
          />
        </div>

        <ButtonGroup>
          {filterCount ? (
            <Button
              onClick={() => {
                setAdvanceFilters(!showAdvanceFilters)
              }}
              size="base"
              subtle
              variant="info"
            >
              <span className="pr-xxs">
                <Badge value={filterCount} variant="info" /> Filters Applied
              </span>

              <Icon Icon={MdManageSearch} />
            </Button>
          ) : (
            <Button
              onClick={() => {
                setAdvanceFilters(!showAdvanceFilters)
              }}
              size="base"
              subtle
              variant="neutral"
            >
              <span className="pr-xxs">Filters</span>

              <Icon Icon={MdManageSearch} />
            </Button>
          )}

          {(!!filtersState.activityTypeIds?.length ||
            filtersState.selectedDateTimeRange.end ||
            filtersState.selectedDateTimeRange.start ||
            !!filtersState.selectedEntryTypeIds?.length ||
            !!filtersState.selectedUserIds?.length ||
            searchText) && (
            <Button
              onClick={() => {
                setFiltersState({
                  activityTypeIds: undefined,
                  selectedDateTimeRange: {end: undefined, start: undefined},
                  selectedEntryTypeIds: undefined,
                  selectedUserIds: undefined,
                })
                setSearchText('')
                setAdvanceFilters(false)
              }}
              subtle
            >
              <Icon color="critical" Icon={IoClose} /> Clear
            </Button>
          )}
        </ButtonGroup>
      </div>

      {showAdvanceFilters && (
        <LocationLogEntrySearchFiltersModal
          filtersState={filtersState}
          onClose={() => setAdvanceFilters(false)}
          userRolesFilter={['ops']}
          setFiltersState={setFiltersState}
        />
      )}
    </div>
  )
}

export {LocationLogEntrySearchFilters}
